import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import 'react';
import { Heading } from '../Heading/Heading.es.js';
import '../../../utils/heading-level-context/HeadingLevelContext.es.js';

const Styles = labelStyles("TableTitleArea", {
  root: css`
    display: grid;
    grid-template-columns: 1fr max-content;
    gap: var(--zds-space-20);
    align-items: center;
    background-color: ${Colors.PrimeWhite};
  `,
  title: css`
    color: ${Colors.TextDefault};
    ${Typography.SectionHeader};
  `
});
const TableTitle = (props) => {
  return jsx(Heading, { css: Styles.title }, props.children);
};
const TableTitleArea = ({ children, kind = "standard" }) => {
  return jsx("header", { css: Styles.root, "data-kind": kind, "data-zds": true }, children);
};

export { TableTitle, TableTitleArea };
//# sourceMappingURL=TableTitleArea.es.js.map
